<template>
  <section id="contact" class="section contact" aria-labelledby="contact-title">
    <div class="container">
      <h2 id="contact-title" class="title">{{ t('contact.title') }}</h2>
      <p class="subtitle">{{ t('contact.subtitle') }}</p>
      <form class="form" @submit.prevent="onSubmit" novalidate>
        <div class="row">
          <label>
            <span>{{ t('contact.name') }}</span>
            <input v-model="form.name" type="text" required />
          </label>
          <label>
            <span>{{ t('contact.email') }}</span>
            <input v-model="form.email" type="email" required />
          </label>
        </div>
        <label class="full">
          <span>{{ t('contact.message') }}</span>
          <textarea v-model="form.message" rows="5" required></textarea>
        </label>
        <button type="submit" class="send">{{ t('contact.send') }}</button>
        <p v-if="sent" class="success" role="status">{{ t('contact.success') }}</p>
      </form>
    </div>
  </section>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const form = reactive({ name: '', email: '', message: '' })
const sent = ref(false)

function onSubmit() {
  // Fake submit demo
  sent.value = true
  setTimeout(() => (sent.value = false), 4000)
  form.name = ''
  form.email = ''
  form.message = ''
}
</script>

<style scoped>
.section.contact {
  position: relative; z-index: 0; overflow: hidden;
  padding: 5rem 1.5rem 6rem;
  background: linear-gradient(180deg, rgba(10,14,28,1) 0%, rgba(8,12,24,1) 100%);
}
.section.contact::before {
  content: '';
  position: absolute; inset: -26%; z-index: -1; pointer-events: none;
  background: radial-gradient(45% 55% at 20% 15%, rgba(96,165,250,0.32), transparent 60%),
              radial-gradient(45% 55% at 80% 90%, rgba(37,99,235,0.30), transparent 60%),
              radial-gradient(40% 45% at 60% 50%, rgba(59,130,246,0.22), transparent 60%);
  animation: aurora 22s ease-in-out infinite alternate;
  mix-blend-mode: screen;
}
.container { max-width: 900px; margin: 0 auto; }
.title { color: #e6f0ff; font-size: clamp(1.6rem, 4vw, 2.2rem); text-align: center; }
.subtitle { color: #9fb0ff; text-align: center; margin-bottom: 2rem; }
.form { display: grid; gap: 1rem; }
.row { display: grid; gap: 1rem; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); }
label { display: grid; gap: .5rem; color: #c8d6ff; }
input, textarea {
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 12px; padding: .75rem .9rem; color: #eaf1ff;
}
input:focus, textarea:focus { outline: none; border-color: #60a5fa; box-shadow: 0 0 0 3px rgba(59,130,246,.20); }
.send {
  justify-self: start;
  padding: .75rem 1.2rem; border-radius: 12px; border: none; cursor: pointer; color: white;
  background: linear-gradient(135deg,#60a5fa,#2563eb);
  box-shadow: 0 10px 24px rgba(59, 130, 246, .30);
}
.success { color: #5be37d; margin-top: .5rem; }

@keyframes aurora {
  0% { transform: translate3d(-2%, -1%, 0) scale(1.03); filter: hue-rotate(0deg) saturate(1.15); }
  50% { transform: translate3d(1.5%, 2%, 0) scale(1.06); filter: hue-rotate(20deg) saturate(1.2); }
  100% { transform: translate3d(-1%, 1%, 0) scale(1.02); filter: hue-rotate(-10deg) saturate(1.15); }
}
@media (prefers-reduced-motion: reduce) {
  .section.contact::before { animation: none; }
}
</style>
